import React from 'react';
import { Row, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';

export default props => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <div className={'form-group'}>
            <span className={'font-weight-bold'}>Coverage *</span>
            <select
              className={'form-control'}
              value={props.item.policy_type_id.value}
              onChange={e =>
                props.updateCoverage(e.currentTarget.value, 'policy_type_id')
              }
            >
              {props.optionPolicyTypes}
            </select>
          </div>
        </Col>
        <Col>
          <LabelInput
            name={'Limit'}
            type={'text'}
            required={true}
            {...props.item.maximum}
            onChange={e =>
              props.updateCoverage(e.currentTarget.value, 'maximum')
            }
            list={'limits'}
          />

          <datalist id="limits">
            <option>$1,000,000</option>
            <option>$2,000,000</option>
            <option>$3,000,000</option>
            <option>$5,000,000</option>
            <option>$10,000,000</option>
            <option>$15,000,000</option>
            <option>$25,000,000</option>
            <option>$50,000,000</option>
          </datalist>
        </Col>
        <Col>
          <LabelInput
            name={'Deductible'}
            type={'text'}
            {...props.item.deductible}
            onChange={e =>
              props.updateCoverage(e.currentTarget.value, 'deductible')
            }
            list={'limits'}
          />
        </Col>

        <div className={'flex-shrink-1 pt-4 pr-3'}>
          <Button
            color={'danger'}
            className={props.index === 0 ? 'invisible' : ''}
            type={'button'}
            onClick={props.onRemove}
          >
            X
          </Button>
        </div>
      </Row>
      {props.optionPolicyList[props.item.policy_type_id.value] ===
        'Auto Liability' && (
        <Row
          style={{ marginTop: '-15px' }}
          className={'position-relative mb-1'}
        >
          <Col>
            <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
              <Label check>
                <Input
                  style={{ top: '5px' }}
                  type="checkbox"
                  checked={props.item.hired.value}
                  onChange={e =>
                    props.updateCoverage(e.currentTarget.checked, 'hired')
                  }
                />{' '}
                Hired
              </Label>
            </FormGroup>
            <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
              <Label check>
                <Input
                  style={{ top: '5px' }}
                  type="checkbox"
                  checked={props.item.non_owned.value}
                  onChange={e =>
                    props.updateCoverage(e.currentTarget.checked, 'non_owned')
                  }
                />{' '}
                Non-owned
              </Label>
            </FormGroup>
            <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
              <Label check>
                <Input
                  style={{ top: '5px' }}
                  type="checkbox"
                  checked={props.item.garage_keepers.value}
                  onChange={e =>
                    props.updateCoverage(
                      e.currentTarget.checked,
                      'garage_keepers'
                    )
                  }
                />{' '}
                Garage Keepers
              </Label>
            </FormGroup>
            <FormGroup check className={'pb-3 pt-2 float-left'}>
              <Label check>
                <Input
                  style={{ top: '5px' }}
                  type="checkbox"
                  checked={props.item.scheduled.value}
                  onChange={e =>
                    props.updateCoverage(e.currentTarget.checked, 'scheduled')
                  }
                />{' '}
                Scheduled
              </Label>
            </FormGroup>
          </Col>
        </Row>
      )}
      {props.optionPolicyList[props.item.policy_type_id.value] ===
        'Directors & Officers Liability' && (
        <Row
          style={{ marginTop: '-15px' }}
          className={'position-relative mb-1'}
        >
          <Col>
            <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
              <Label check>
                <Input
                  style={{ top: '5px' }}
                  type="checkbox"
                  checked={props.item.claims_made.value}
                  onChange={e =>
                    props.updateCoverage(e.currentTarget.checked, 'claims_made')
                  }
                />{' '}
                Claims Made
              </Label>
            </FormGroup>
            <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
              <Label check>
                <Input
                  style={{ top: '5px' }}
                  type="checkbox"
                  checked={props.item.occurrence.value}
                  onChange={e =>
                    props.updateCoverage(e.currentTarget.checked, 'occurrence')
                  }
                />{' '}
                Occurrence
              </Label>
            </FormGroup>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};
